export const DEFAULT_FONT_FAMILY = 'Outfit, sans-serif';

export const DEFAULT_LOADER_SIZE = 20;

export enum Size {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum TokenSize {
  ExtraSmall = 'extraSmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum TabType {
  Internal = 'internal',
  External = 'external',
  Embedded = 'embedded',
  Text = 'text',
}

export enum TableVariant {
  Contained = 'contained',
}

export enum Variant {
  Contained = 'contained',
  Secondary = 'secondary',
  Text = 'text',
  Icon = 'icon',
}

export enum Breakpoint {
  Xl = 'xl',
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xs = 'xs',
}

export enum BreakpointSize {
  Xl = 1440,
  Lg = 1280,
  Md = 860,
  Sm = 600,
  Xs = 375,
}

export const HEADER_HEIGHT_DESKTOP = 88;

export const DESKTOP_TOTAL_HEIGHT = 292;

export const HEADER_HEIGHT_MOBILE = HEADER_HEIGHT_DESKTOP;

export const FOOTER_HEIGHT_MOBILE = 694;

export const MOBILE_TOTAL_HEIGHT = HEADER_HEIGHT_MOBILE + FOOTER_HEIGHT_MOBILE;
